import { useEffect } from "react";

export default function Terms() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const last = "April 13, 2026";

  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif", padding: "80px 24px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        h1 { font-family: 'DM Serif Display', serif; font-size: 36px; font-weight: 400; margin-bottom: 8px; }
        h2 { font-size: 16px; font-weight: 500; color: #f0ede8; margin: 32px 0 10px; }
        p { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 12px; }
        ul { padding-left: 20px; margin-bottom: 12px; }
        li { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 4px; }
        a { color: #7B5EA7; text-decoration: none; }
        hr { border: none; border-top: 0.5px solid rgba(255,255,255,0.07); margin: 32px 0; }
      `}</style>

      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <a href="/" style={{ fontSize: 13, color: "rgba(240,237,232,0.4)", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 40 }}>← Back to Creator Protect</a>

        <h1>Terms of Service</h1>
        <p style={{ fontSize: 13, color: "rgba(240,237,232,0.35)", marginBottom: 40 }}>Last updated: {last}</p>

        <p>These Terms of Service govern your use of Creator Protect ("Service"), operated by Creator Protect ("we," "us," or "our"). By creating an account or using our Service, you agree to these terms.</p>

        <hr />

        <h2>1. Description of service</h2>
        <p>Creator Protect provides content protection services for digital content creators, including content fingerprinting and, where available, watermarking; automated leak detection; and DMCA takedown filing. We act as your authorized DMCA agent when filing takedown notices on your behalf.</p>

        <h2>2. Eligibility</h2>
        <p>You must be at least 18 years of age to use Creator Protect. By using our Service, you represent and warrant that you are 18 years of age or older and have the legal capacity to enter into these Terms.</p>

        <h2>3. Your content and ownership</h2>
        <p>You retain full ownership of all content you upload to Creator Protect. By uploading content, you grant us a limited license to process, fingerprint, and (where applicable) watermark your content solely for the purpose of providing our protection services. We do not claim any ownership rights over your content.</p>
        <p>You represent and warrant that:</p>
        <ul>
          <li>You own or have the legal right to upload and protect the content</li>
          <li>You have obtained all necessary consents from any individuals appearing in your content</li>
          <li>Your content does not violate any applicable laws or third-party rights</li>
          <li>You are the rightful copyright holder or authorized agent for the content you submit for protection</li>
        </ul>

        <h2>4. DMCA authorized agent</h2>
        <p>By using our DMCA filing service, you authorize Creator Protect to act as your designated DMCA agent and to file takedown notices on your behalf. You confirm that the content submitted for protection is your original work or that you have the legal right to file takedown notices for it. Filing false DMCA notices is a violation of these Terms and may expose you to legal liability.</p>

        <h2>5. Prohibited uses</h2>
        <p>You may not use Creator Protect to:</p>
        <ul>
          <li>File DMCA notices for content you do not own or have rights to</li>
          <li>Upload content that depicts minors in any sexual or inappropriate manner</li>
          <li>Harass, threaten, or harm any individual</li>
          <li>Violate any applicable local, state, national, or international law</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Reverse engineer or attempt to extract our proprietary watermarking technology</li>
        </ul>

        <h2>6. Subscription and billing</h2>
        <p>Creator Protect offers subscription plans billed monthly. All plans include a 3-day free trial. Your card will not be charged until the trial period ends. You may cancel at any time before the trial ends to avoid being charged. Subscriptions automatically renew until cancelled. Refunds are not provided for partial billing periods.</p>

        <h2>7. Service availability</h2>
        <p>We strive to maintain high availability of our Service but do not guarantee uninterrupted access. We are not liable for any losses resulting from service downtime or interruptions.</p>

        <h2>8. Limitation of liability</h2>
        <p>Creator Protect is not liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Our total liability to you for any claims arising from these Terms shall not exceed the amount you paid us in the 3 months preceding the claim.</p>

        <h2>9. Disclaimer of warranties</h2>
        <p>Creator Protect is provided "as is" without warranties of any kind. We do not guarantee that our watermarking or detection technology will identify every instance of unauthorized distribution of your content.</p>

        <h2>10. Termination</h2>
        <p>We reserve the right to suspend or terminate your account if you violate these Terms. You may terminate your account at any time by contacting us at support@creatorprotect.io.</p>

        <h2>11. Changes to terms</h2>
        <p>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>

        <h2>12. Governing law</h2>
        <p>These Terms are governed by the laws of the State of Florida, United States, without regard to conflict of law principles.</p>

        <h2>13. Contact</h2>
        <p>For questions about these Terms, contact us at <a href="mailto:legal@creatorprotect.io">legal@creatorprotect.io</a>.</p>

        <hr />
        <p style={{ fontSize: 12, color: "rgba(240,237,232,0.25)" }}>© 2026 Creator Protect. All rights reserved.</p>
      </div>
    </div>
  );
}
